import React, { useEffect, useState, } from "react";
import { Button, Card, DatePicker, Divider, Select, Space, Tooltip, Typography } from 'antd';
import dayjs from "dayjs";
import axios from "axios";
import { API_DOMAIN } from "../../components/constants";
// import { SearchOutlined } from "@mui/icons-material";
import useSnackbar from "../../components/Snackbar/UseSnackbar";
import { InfoCircleOutlined, SearchOutlined } from '@ant-design/icons';
const { RangePicker } = DatePicker;
const { Title, Paragraph, Text, Link } = Typography;

const ReportsAll = () => {
    const { SuccessSnackbar, ErrorSnackbar, InfoSnackbar, WarningSnackbar, ToastContainer } = useSnackbar();

    const rangePresets = [
        {
            label: 'Last 90 Days',
            value: [dayjs().add(-90, 'd'), dayjs()],
        },
        {
            label: 'Last 60 Days',
            value: [dayjs().add(-60, 'd'), dayjs()],
        },
        {
            label: 'Last 30 Days',
            value: [dayjs().add(-30, 'd'), dayjs()],
        },
        {
            label: 'Last 14 Days',
            value: [dayjs().add(-14, 'd'), dayjs()],
        },
        {
            label: 'Last 7 Days',
            value: [dayjs().add(-7, 'd'), dayjs()],
        },
        {
            label: 'Yesterday',
            value: [dayjs().add(-1, 'd'), dayjs().add(-1, 'd')],
        },
        {
            label: 'Today',
            value: [dayjs(), dayjs()],
        }
    ];

    const [overallReport, setOVerallReport] = useState(null)
    const [usersSet, setUsersSet] = useState([]);

    const [from, setFrom] = useState(dayjs().startOf('month'))
    const [to, setTo] = useState(dayjs().endOf('month'))
    const [searchLoading, setSearchLoading] = useState(false)
    const [searchUser, setSearchUser] = useState(null);


    const loadOveraellReport = async () => {
        setSearchLoading(true)
        try {
            const res = await axios.post(API_DOMAIN + "/reports/overall_summary", {
                from: from.format("YYYY-MM-DD"),
                to: to.format("YYYY-MM-DD"),
                user: searchUser
            });
            if (res.data.success) {
                setOVerallReport(res.data.data)
            } else {
                ErrorSnackbar("Something went wrong while fetching the data");
            }
        } catch (error) {
            ErrorSnackbar(error.message);
        }
        finally {
            setSearchLoading(false)
        }
    };

    const load_users = async () => {
        const res = await axios.get(API_DOMAIN + "/whatsapp/get_users")
        if (res.data.success) {
            setUsersSet(res.data.data.map(element => ({ value: element.id, label: element.name })));
        } else {
            ErrorSnackbar("Something went wrong while fetching users list");
        }

    };
    const onSearchDateChange = (dates) => {
        if (dates) {
            const [start, end] = dates;
            setFrom(start);
            setTo(end);
        }
        else {
            setFrom(null);
            setTo(null);
        }
    };

    useEffect(() => {
        loadOveraellReport();
        load_users();
    }, []);

    const reloadOverallReport = async () => {
        loadOveraellReport();
    }

    return (
        <div>
            <div className="flex justify-between drop-shadow" style={{ width: "100%", backgroundColor: "#64aafa", border: "1px solid #64aafa", borderRadius: "5px", overflowY: "auto", position: "sticky", top: 70, zIndex: "1000", }}>
                <div className="flex p-2.5 flex-wrap gap-1.5" style={{ minWidth: "80%" }}>

                    <RangePicker style={{ width: "225px" }} presets={rangePresets} value={[from, to]} onChange={onSearchDateChange} maxDate={dayjs()} />


                    <Select
                        style={{ maxWidth: "225px" }}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        id="search_select"

                        onChange={(e) => setSearchUser(e)}
                        placeholder="Select User"
                        options={usersSet}
                    />

                    <Button style={{ width: "60px" }} type="primary" onClick={reloadOverallReport} loading={searchLoading}>
                        <SearchOutlined />
                    </Button>

                </div>
            </div>
            {from && to ? (<Typography>
                <Title style={{ fontSize: "20px" }} className="flex justify-center mt-2">
                    Overall Sales Report Between {from?.format("YYYY-MM-DD")} and {to?.format("YYYY-MM-DD")}
                </Title>
            </Typography>) : null}


            <div className="mt-4">
                <Space direction="horizontal" size={16}>
                    <Card loading={searchLoading} title={`TOTAL ENQUIRIES - ${overallReport?.b2c_enquiries?.[0]?.value + overallReport?.b2c_enquiries?.[1]?.value + overallReport?.b2b_enquiries?.[0]?.value + overallReport?.b2b_enquiries?.[1]?.value}`} className="shadow-1" extra={<a href="#">More</a>} style={{ width: 300 }}>
                        <div className="border rounded p-2 shadow-1">
                            <p style={{ fontWeight: "650" }}>B2B</p>

                            <div className="flex justify-between">
                                <span>International</span>
                                <span style={{ fontWeight: "600" }}>{overallReport?.b2b_enquiries?.[0]?.value}</span>
                            </div>

                            <div className="flex justify-between">
                                <span>Local</span>
                                <span style={{ fontWeight: "600" }}>{overallReport?.b2b_enquiries?.[1]?.value}</span>
                            </div>

                            <Divider type="horizontal" className="p-0 m-0" />
                            <div className="flex justify-between">
                                <span>Total</span>

                                <span style={{ fontWeight: "600" }}>{overallReport?.b2b_enquiries?.[0]?.value + overallReport?.b2b_enquiries?.[1]?.value}</span>
                            </div>

                        </div>

                        <div className="border rounded p-2 shadow-1 mt-2">
                            <p style={{ fontWeight: "650" }}>B2C</p>

                            <div className="flex justify-between">
                                <span>International</span>
                                <span style={{ fontWeight: "600" }}>{overallReport?.b2c_enquiries?.[0]?.value}</span>
                            </div>

                            <div className="flex justify-between">
                                <span>Local</span>
                                <span style={{ fontWeight: "600" }}>{overallReport?.b2c_enquiries?.[1]?.value}</span>
                            </div>

                            <Divider type="horizontal" className="p-0 m-0" />
                            <div className="flex justify-between">
                                <span>Total</span>

                                <span style={{ fontWeight: "600" }}>{overallReport?.b2c_enquiries?.[0]?.value + overallReport?.b2c_enquiries?.[1]?.value}</span>
                            </div>

                        </div>
                    </Card>

                    <Card loading={searchLoading} title={`B2B Splitup`} className="shadow-1" extra={<a href="#">More</a>} style={{ width: 300 }}>

                        <div className="border rounded p-2 shadow-1">
                            <p style={{ fontWeight: "650" }}>B2B Info</p>

                            <div className="flex justify-between">
                                <span>Qouted</span>
                                <span style={{ fontWeight: "600" }}>
                                    <span>{`(🌐${overallReport?.b2b_splitup?.[2]?.value}+${overallReport?.b2b_splitup?.[3]?.value}) `}</span>
                                    <span>{overallReport?.b2b_splitup?.[2]?.value + overallReport?.b2b_splitup?.[3]?.value}</span>
                                </span>
                            </div>

                            <div className="flex justify-between">
                                <span>Closed</span>
                                <span style={{ fontWeight: "600" }}>
                                    <span>{`(🌐${overallReport?.b2b_splitup?.[4]?.value}+${overallReport?.b2b_splitup?.[5]?.value}) `}</span>
                                    <span>{overallReport?.b2b_splitup?.[4]?.value + overallReport?.b2b_splitup?.[5]?.value}</span>
                                </span>
                            </div>

                            <div className="flex justify-between">
                                <span>Postponed</span>
                                <span style={{ fontWeight: "600" }}>
                                    <span>{`(🌐${overallReport?.b2b_splitup?.[8]?.value}+${overallReport?.b2b_splitup?.[9]?.value}) `}</span>
                                    <span>{overallReport?.b2b_splitup?.[8]?.value + overallReport?.b2b_splitup?.[9]?.value}</span>
                                </span>
                            </div>

                            <div className="flex justify-between">
                                <span>Others&nbsp;<Tooltip title="Either Query Lost or Item Unavailable or No Price Received"><InfoCircleOutlined className="cursor-pointer" /></Tooltip></span>
                                <span style={{ fontWeight: "600" }}>{overallReport?.b2b_splitup?.[3]?.value + overallReport?.b2b_splitup?.[4]?.value
                                    + overallReport?.b2b_splitup?.[6]?.value}</span>
                            </div>

                            <Divider type="horizontal" className="p-0 m-0" />
                            <div className="flex justify-between">
                                <span className="font-bold">Total</span>

                                <span className="font-bold">
                                    <span>{`(🌐${overallReport?.b2b_splitup?.[0]?.value}+${overallReport?.b2b_splitup?.[1]?.value}) `}</span>
                                    <span>{overallReport?.b2b_splitup?.[0]?.value + overallReport?.b2b_splitup?.[1]?.value}</span>
                                </span>
                            </div>

                        </div>

                    </Card>

                    <Card loading={searchLoading} title={`B2C Splitup`} className="shadow-1" extra={<a href="#">More</a>} style={{ width: 300 }}>

                        <div className="border rounded p-2 shadow-1">
                            <p style={{ fontWeight: "650" }}>B2C Info</p>

                            <div className="flex justify-between">
                                <span>Qouted</span>
                                <span style={{ fontWeight: "600" }}>
                                    <span>{`(🌐${overallReport?.b2c_splitup?.[2]?.value}+${overallReport?.b2c_splitup?.[3]?.value}) `}</span>
                                    <span>{overallReport?.b2c_splitup?.[2]?.value + overallReport?.b2c_splitup?.[3]?.value}</span>
                                </span>
                            </div>

                            <div className="flex justify-between">
                                <span>Closed</span>
                                <span style={{ fontWeight: "600" }}>
                                    <span>{`(🌐${overallReport?.b2c_splitup?.[4]?.value}+${overallReport?.b2c_splitup?.[5]?.value}) `}</span>
                                    <span>{overallReport?.b2c_splitup?.[4]?.value + overallReport?.b2c_splitup?.[5]?.value}</span>
                                </span>
                            </div>

                            <div className="flex justify-between">
                                <span>Postponed</span>
                                <span style={{ fontWeight: "600" }}>
                                    <span>{`(🌐${overallReport?.b2c_splitup?.[8]?.value}+${overallReport?.b2c_splitup?.[9]?.value}) `}</span>
                                    <span>{overallReport?.b2c_splitup?.[8]?.value + overallReport?.b2c_splitup?.[9]?.value}</span>
                                </span>
                            </div>

                            <div className="flex justify-between">
                                <span>Others&nbsp;<Tooltip title="Either Query Lost or Item Unavailable or No Price Received"><InfoCircleOutlined className="cursor-pointer" /></Tooltip></span>
                                <span style={{ fontWeight: "600" }}>{overallReport?.b2c_splitup?.[3]?.value + overallReport?.b2c_splitup?.[4]?.value
                                    + overallReport?.b2c_splitup?.[6]?.value}</span>
                            </div>

                            <Divider type="horizontal" className="p-0 m-0" />
                            <div className="flex justify-between">
                                <span className="font-bold">Total</span>

                                <span style={{ fontWeight: "600" }}>
                                    <span>{`(🌐${overallReport?.b2c_splitup?.[0]?.value}+${overallReport?.b2c_splitup?.[1]?.value}) `}</span>
                                    <span>{overallReport?.b2c_splitup?.[0]?.value + overallReport?.b2c_splitup?.[1]?.value}</span>
                                </span>
                            </div>

                        </div>

                    </Card>

                </Space>
            </div>



        </div>
    );
}

export default ReportsAll;